const langContact = {
	// Position
	head_of_sales_private_credit: {
		tag: 'contact.position.head_of_sales_private_credit',
		fr: 'Head of Sales Private Credit',
		en: 'Head of Sales Private Credit',
	},
	investor_relations: {
		tag: 'contact.position.investor_relations',
		fr: 'Chargé de Relations Investisseurs',
		en: 'Investor Relations',
	},
	director_of_development: {
		tag: 'contact.position.director_of_development',
		fr: 'Directeur du Développement',
		en: 'Director of Development',
	},
	investor_relations_officer: {
		tag: 'contact.position.investor_relations_officer',
		fr: 'Chargé de Relations Investisseurs',
		en: 'Investor Relations Officer',
	},
	head_of_venture_capital: {
		tag: 'contact.position.head_of_venture_capital',
		fr: 'Head of Venture Capital',
		en: 'Head of Venture Capital',
	},
	partner_venture_capital: {
		tag: 'contact.position.partner_venture_capital',
		fr: 'Partner Venture Capital',
		en: 'Partner Venture Capital',
	},
	chief_investment_officer: {
		tag: 'contact.position.chief_investment_officer',
		fr: 'Chief Investment Officer',
		en: 'Chief Investment Officer',
	},
	head_of_private_equity: {
		tag: 'contact.position.head_of_private_equity',
		fr: 'Head of Private Equity',
		en: 'Head of Private Equity',
	},
	partner_private_equity: {
		tag: 'contact.position.partner_private_equity',
		fr: 'Partner Private Equity',
		en: 'Partner Private Equity',
	},
	head_of_multi_manager_private_equity: {
		tag: 'contact.position.head_of_multi_manager_private_equity',
		fr: 'Head of Multi-Manager Private Equity',
		en: 'Head of Multi-Manager Private Equity',
	},
	client_service_officer_woman: {
		tag: 'contact.position.client_service_officer_woman',
		fr: 'Chargée de Service Client',
		en: 'Client Service Officer',
	},
	client_service_officer_man: {
		tag: 'contact.position.client_service_officer_man',
		fr: 'Chargé de Service Client',
		en: 'Client Service Officer',
	},
	head_of_client_service: {
		tag: 'contact.position.head_of_client_service',
		fr: 'Responsable du Service Client',
		en: 'Head of Client Service',
	},
	sales_director_woman: {
		tag: 'contact.position.sales_director_woman',
		fr: 'Directrice Commerciale',
		en: 'Sales Director',
	},
	sales_director_man: {
		tag: 'contact.position.sales_director_man',
		fr: 'Directeur Commercial',
		en: 'Sales Director',
	},
};

export default langContact;
